module.exports = __webpack_public_path__ + "img/thank6.3e252474.gif";